import { Component, OnInit } from '@angular/core';
import { AdDataService } from '../services/addata.service';
import { AdconfirmationService } from '../service/adconfirmation.service';
import { Router } from '@angular/router';
import { AdbookingService } from '../services/adbooking.service';
import { UserdataService } from '../services/userdata.service';

@Component({
  selector: 'app-adconfirmation1',
  templateUrl: './adconfirmation1.component.html',
  styleUrls: ['./adconfirmation1.component.css']
})
export class Adconfirmation1Component implements OnInit {

  adDetails: any;
  orderId: string;
  
  user: { userdata: any; };

  displayadModel: any;
  adconfirmModel: any;
  selectedDates: any;
  adDates: any;
  User: any;
  cost: any;
  component: string;
  filename: string;
  email: string;
  orderid: any;
  searchorder: any;
  adContent: any;
 

  constructor(private addata: AdDataService,
              private userdataservice: UserdataService,
              private adconfirmation: AdconfirmationService,
              private adservice: AdDataService,
              private router: Router,
              private adbookingservice :AdbookingService,
              private bookingService: AdbookingService
  ) {

  }

  ngOnInit() {
    
    this.userdataservice.getUserDataSubject().subscribe(data => {
       this.email = data['email'];
    });

    
  

    this.displayadModel = JSON.parse(sessionStorage.getItem('Array'));
    if (this.displayadModel) {
      this.selectedDates = (sessionStorage.getItem('selectedDate'));
      this.filename = this.displayadModel.imagename;
      this.adContent = this.displayadModel.adContent
      console.log(this.adContent)
      console.log(this.filename);
      this.orderid = this.displayadModel.orderid;
      this.User = JSON.parse(sessionStorage.getItem('User'));
      console.log(this.displayadModel.noOfAdDays)
      this.cost = parseFloat(this.displayadModel.adcost) * parseFloat(this.displayadModel.noOfAdDays);
      this.displayadModel.igst = (parseFloat(this.cost) * 5.00 / 100).toFixed(2);
      this.displayadModel.cgst = (parseFloat(this.cost) * 2.5 / 100).toFixed(2);
      this.displayadModel.sgst = (parseFloat(this.cost) * 2.5 / 100).toFixed(2);
      if(this.displayadModel.location=='Meghalaya'){
      this.displayadModel.totalCost = (parseFloat(this.cost)+ parseFloat(this.displayadModel.cgst) + parseFloat(this.displayadModel.sgst) + 30 + 100).toFixed(2);
     }
     if(this.displayadModel.location !='Meghalaya'){
      this.displayadModel.totalCost = (parseFloat(this.displayadModel.igst) + parseFloat(this.cost)+ parseFloat(this.displayadModel.cgst) + parseFloat(this.displayadModel.sgst) + 30 + 100).toFixed(2);
     }
      sessionStorage.setItem('Array', JSON.stringify(this.displayadModel));

      
    }
    // sessionStorage.removeItem(this.displayadModel);

  }

  clearSessionData() {
    sessionStorage.clear();
    this.adservice.setAdData(null);
    this.router.navigate(['/home']);
    // console.log("session cleared");
  }

 download(filename){
   this.adbookingservice.getFile(this.email,this.orderid,this.filename).subscribe(
 
    resp => {
     console.log(resp);
     const downloadURL = window.URL.createObjectURL(resp);
        const link = document.createElement('a');
        link.href = downloadURL;
        link.download = filename;
        link.click();
        link.remove();
       
      
    });
 }


}
